{
  "TemplatingEngineUrl": "https://pon-universe-templateengine.azurewebsites.net",
  "AppInsightsConnectionString": "InstrumentationKey=c2452247-2dea-4976-aa86-16c02e960c9f;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f32c75b4-ab4c-4548-9c91-0e79f9aebc18",
  "EnableApplicationInsights": true,
  "DapUrl": "https://dap-pon.mendixcloud.com/link/Contract/",
  "FeatureSwitches": {
    "EnableLeaseCompanies": true
  },
  "EnableInactivityTimer": false
}
